const isActive =
  (current = []) =>
  (match, location) =>
    current.includes(location.pathname);

export const urls = {
  archive: {
    hash: "pegasus-stories",
    path: "/pegasus-stories",
    text: "Pegasus Stories",
    subtitle:
      "View stories from human rights defenders targeted by NSO Group's Pegasus",
    inNavBar: true,
    isActive: isActive(["/pegasus-stories"]),
  },
  explore: {
    hash: "explore",
    path: "/explore",
    text: "The Platform",
    subtitle:
      "Explore the most comprehensive database of incidents related to the NSO Group",
    inNavBar: true,
    isActive: isActive(["/explore", "/platform"]),
  },
  platform: {
    hash: "platform",
    path: "/platform",
    text: "The Platform",
    isActive: isActive(["/explore", "/platform"]),
  },
  corporate: {
    hash: "corporate",
    path: "/corporate",
    text: "The Company",
    subtitle:
      "View an interactive reconstruction of NSO Group's corporate network",
    inNavBar: true,
    isActive: isActive(["/corporate"]),
  },
  fleming: {
    hash: "fleming",
    path: "/fleming",
    text: "Covid 19 surveillance",
    inNavBar: false,
    isActive: isActive(["/fleming"]),
  },
  root: {
    path: "/",
    text: "",
    inNavBar: false,
    isActive: isActive(["/"]),
  },
  soundmachine: {
    hash: "soundmachine",
    path: "/soundmachine",
    text: "Listen to the Data",
    subtitle:
      "Experience a sonic rendering of the dataset, produced by Brian Eno",
    inNavBar: true,
    isActive: isActive(["/soundmachine"]),
  },
  caseStudies: {
    hash: "case-studies",
    path: "/case-studies",
    text: "Case Studies",
    inNavBar: false,
    isActive: isActive(["/case-studies"]),
  },
};

export const landingUrls = {
  archive: urls.archive,
  explore: urls.explore,
  corporate: urls.corporate,
  soundmachine: urls.soundmachine,
};
